import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import SidebarManager from "./SidebarManager.layout";

const mapStateToProps = (state) => ({
    sidebarOpenedItem: state.app.sidebarOpenedItem,
    trackers: state.allTrackersState.trackers,
    trackersStatus: state.allTrackersState.status,
    language: state.languagesState.languages,
    bussiness: state.allDashboardDatasState.getAllDashboardDatas.bussiness,
    activeTrackers: state.allTrackersState.trackers,
    isSidebarOpen: state.app.isSidebarOpen,
    subscriptionModal: state.app.subscriptionModal,
});

const mapDispatchToProps = (dispatch) => ({});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(SidebarManager);
